import React from 'react';
interface IconProps {
  fill: string;
  height: string | number;
  width: string | number;
}

function GoalsIcon({ fill, height, width }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 39 23">
      <path
        fill={fill}
        d="M27 .25l4.294 4.294-9.15 9.15-7.5-7.5L.75 20.106l2.644 2.644 11.25-11.25 7.5 7.5L33.956 7.206 38.25 11.5V.25H27z"
      ></path>
    </svg>
  );
}

export default GoalsIcon;
